/**
 * Constants for Slider component
 */

export const THRESHOLD_STEPS = [
  { low: "0.99", high: "1.00" },
  { low: "1.99", high: "2.00" },
  { low: "2.99", high: "3.00" },
  { low: "3.99", high: "4.00" },
  { low: "4.99", high: "5.00" },
  { low: "5.99", high: "6.00" },
  { low: "6.99", high: "7.00" },
  { low: "7.99", high: "8.00" },
  { low: "8.99", high: "9.00" },
  { low: "9.99", high: "10.00" },
] as const;

export const SLIDER_LABELS = {
  RISK_STATUS_THRESHOLD: "Risk Status Thresholds",
  HIGH_LABEL: "High",
  MEDIUM_LABEL: "Medium",
  LOW_LABEL: "Low",
  MODIFIED_VALUES: "Values: Modified",
  VALUES: "Values",
  ORIGINAL_VALUES: "Previous",
  MIN_VALUE: "0.00",
  MAX_VALUE: "10.00",
} as const;

export const SLIDER_COLORS = {
  HIGH_RISK: "#D32F2F",
  MEDIUM_RISK: "#F9A825",
  LOW_RISK: "#2E7D32",
} as const;

export const TOOLTIP_COLORS = {
  RED: "red",
  ORANGE: "orange",
} as const;
